import { useDrawerState } from '~/hooks/useDrawerState';
import TestRunDrawerView from './TestRunDrawerView';

export function TestRunDrawer() {
  const {
    id: runId,
    opened,
    closeDrawer,
  } = useDrawerState({ queryKey: 'testRunDrawer', keysToRemoveOnClose: ['attemptId'] });

  return (
    <TestRunDrawerView
      runId={runId}
      opened={opened}
      onClose={closeDrawer}
    />
  );
}
